import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { object, func, arrayOf, shape, string, any, bool } from 'prop-types';
import AwaitingFeedback from './AwaitingFeedback';
import Grid from '@material-ui/core/Grid';
import ErrorMsg from '../../scenes/components/ErrorMsg';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(2),
    borderWidth: 2,
  },
  applicationInfo: {
    marginBottom: theme.spacing(4),
  },
  button: {
    margin: theme.spacing(2),
  },
  root: {},
  headerContainer: {},
  titleStyle: {},
  subTitle: {},
  itemMidContainer: {},
  footerContainer: {},
  footerBar: {},
  textFooterTerms: {},
  textFooter: {},
  trademarkText: {},
});

const MessageToAgent = ({
  classes,
  messages,
  docs,
  messageToOfficer,
  messageToApplicant,
  error,
  upload,
  match,
  history,
  isSent,
  email,
  isFetching,
}) => (
  <Grid container justifyContent="center" className={classes.container}>
    {!!error && (
      <Grid item xs={10}>
        <ErrorMsg error={error} />
      </Grid>
    )}
    <Grid item xs={12}>
      <AwaitingFeedback
        messages={messages}
        email={email}
        isSent={isSent}
        docs={docs}
        send={
          match.params.to === 'officer' ? messageToOfficer : messageToApplicant
        }
        error={error}
        upload={upload}
        match={match}
        history={history}
        isFetching={isFetching}
      />
    </Grid>
  </Grid>
);

MessageToAgent.propTypes = {
  classes: object.isRequired,
  messages: arrayOf(
    shape({
      message: string.isRequired,
      uuid: any.isRequired,
      createdAt: string.isRequired,
    })
  ).isRequired,
  send: func.isRequired,
  isFetching: bool.isRequired,
  error: string,
  upload: func.isRequired,
};

export default withStyles(styles)(MessageToAgent);



// WEBPACK FOOTER //
// ./src/view/forms/MessageToAgent/MessageToAgentComponent.js